module.exports = __webpack_public_path__ + "img/poison.7d33dfef.png";